import { Routes, Route, Navigate } from "react-router-dom";
import { PrivateRoutes } from "../utils";
import {
  LoginPage,
  RegisterPage,
  ForgotPasswordPage,
  PasswordResetPage,
} from "../pages";

import Dashboard from "../components/screens/Dashboard";
import DailyEntry from "../components/screens/DailyEntry";
import Pricing from "../components/screens/Pricing";
import Reports from "../components/screens/Reports";
import Settings from "../components/screens/Settings";

import SidebarLayout from "../components/SidebarLayout";
import NoPermission from "../pages/common/noPermisssion";
import { AuthState } from "../context/AuthProvider";

const AppRoutes = () => {
  const { auth } = AuthState();

  return (
    <>
      <Routes>
        <Route path="/no-permission" element={<NoPermission />} />
        <Route element={<PrivateRoutes />}>
          <Route
            path="/"
            element={auth?.role === "Staff" ? <Navigate to="/daily-entry" replace /> : <Navigate to="/dashboard" replace />}
          />
          <Route
            path="/dashboard"
            element={auth?.role === "Admin" ? <SidebarLayout><Dashboard /></SidebarLayout> : <Navigate to="/no-permission" replace />}
          />
          <Route
            path="/daily-entry"
            element={auth?.role === "Admin" || auth?.role === "Staff" ? <SidebarLayout><DailyEntry /></SidebarLayout> : <Navigate to="/no-permission" replace />}
          />
          <Route
            path="/pricing"
            element={auth?.role === "Admin" || auth?.role === "Staff" ? <SidebarLayout><Pricing /></SidebarLayout> : <Navigate to="/no-permission" replace />}
          />
          <Route
            path="/reports"
            element={auth?.role === "Admin" ? <SidebarLayout><Reports /></SidebarLayout> : <Navigate to="/no-permission" replace />}
          />
          <Route
            path="/settings"
            element={auth?.role === "Admin" || auth?.role === "Staff" ? <SidebarLayout><Settings /></SidebarLayout> : <Navigate to="/no-permission" replace />}
          />
        </Route>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/forgotPassword" element={<ForgotPasswordPage />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </>
  );
};

export default AppRoutes;